/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import ReactHLS from 'react-hls';
import styles from './styles';

const streaming_url = process.env.REACT_APP_VIDEO_STREAMING;

const Video = ({ t, classes }) => {
  const { container, separation } = classes;
  return (
    <div className={`${container} ${separation}`}>
      <h3 className={separation}>{t('screens.Video.title')}</h3>
      <p className={separation}>{t('screens.Video.description')}</p>
      <ReactHLS className={separation} url={streaming_url} />
    </div>
  );
};

Video.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(Video));
